module.exports = __webpack_public_path__ + "img/anniversary_2023.b0d10f88.svg";